import { ThemeProvider } from '@mui/material/styles';
import { theme as designSystemTheme } from '@openx/design-system/theme/theme';
import type { ReactNode } from 'react';

export const OpenXAgentDesignSystemTheme = ({ children }: { children: ReactNode }) => (
  <ThemeProvider theme={designSystemTheme}>{children}</ThemeProvider>
);
